function _s(o, i, p, l) {
    void 0 === i && (i = 400),
        void 0 === l && (l = !1),
        (o.style.overflow = "hidden"),
        l && (o.style.display = "block");
    var n,
        t = window.getComputedStyle(o),
        s = parseFloat(t.getPropertyValue("height")),
        a = parseFloat(t.getPropertyValue("padding-top")),
        r = parseFloat(t.getPropertyValue("padding-bottom")),
        y = parseFloat(t.getPropertyValue("margin-top")),
        d = parseFloat(t.getPropertyValue("margin-bottom")),
        g = s / i,
        m = a / i,
        h = r / i,
        u = y / i,
        x = d / i;
    window.requestAnimationFrame(function t(e) {
        void 0 === n && (n = e);
        e -= n;
        l
            ? ((o.style.height = g * e + "px"),
                (o.style.paddingTop = m * e + "px"),
                (o.style.paddingBottom = h * e + "px"),
                (o.style.marginTop = u * e + "px"),
                (o.style.marginBottom = x * e + "px"))
            : ((o.style.height = s - g * e + "px"),
                (o.style.paddingTop = a - m * e + "px"),
                (o.style.paddingBottom = r - h * e + "px"),
                (o.style.marginTop = y - u * e + "px"),
                (o.style.marginBottom = d - x * e + "px")),
            i <= e
                ? ((o.style.height = ""),
                    (o.style.paddingTop = ""),
                    (o.style.paddingBottom = ""),
                    (o.style.marginTop = ""),
                    (o.style.marginBottom = ""),
                    (o.style.overflow = ""),
                    l || (o.style.display = "none"),
                    "function" == typeof p && p())
                : window.requestAnimationFrame(t);
    });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
    0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
    (HTMLElement.prototype.slideUp = function (t, e) {
        _s(this, t, e);
    }),
    (HTMLElement.prototype.slideDown = function (t, e) {
        _s(this, t, e, !0);
    });




document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with data-product-review-note attribute
    const ratingElements = document.querySelectorAll('[data-product-review-note]');

    ratingElements.forEach(element => {
        // Get the rating value (0 to 5)
        const rating = parseFloat(element.getAttribute('data-product-review-note'));

        // Find the SVG within this element
        const svg = element.querySelector('svg');
        if (!svg) return;

        // Get all star paths within the SVG
        const stars = svg.querySelectorAll('path');

        // Loop through each star and set fill color based on rating
        stars.forEach((star, index) => {
            if (index < Math.floor(rating)) {
                // Full star: keep original color (#E64601)
                star.setAttribute('fill', '#EBA698');
            } else if (index === Math.floor(rating) && rating % 1 !== 0) {
                // Partial star: create a gradient for fractional rating
                const gradientId = `partial-star-${index}-${Date.now()}`;
                const gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
                gradient.setAttribute('id', gradientId);
                gradient.innerHTML = `
          <stop offset="${rating % 1 * 100}%" stop-color="#EBA698"/>
          <stop offset="${rating % 1 * 100}%" stop-color="#D3D3D3"/>
        `;
                svg.querySelector('defs') || svg.insertAdjacentHTML('afterbegin', '<defs></defs>');
                svg.querySelector('defs').appendChild(gradient);
                star.setAttribute('fill', `url(#${gradientId})`);
            } else {
                // Empty star: gray color
                star.setAttribute('fill', '#D3D3D3');
            }
        });
    });
});


/* ========== ANCHORS (#... et /#...) ========== */
(function anchorHandler() {
    // one delegate, stop interfering with external links
    document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href*="#"]');
        if (!a) return;

        const href = a.getAttribute('href');
        if (!href || href === '#' || href === '/#') return;

        // only handle same-origin or path-only anchors
        try {
            const url = new URL(href, window.location.origin);
            if (url.origin !== window.location.origin) return; // external
            if (!url.hash) return;

            // normalize id from "#section" or "/#section"
            const targetId = url.hash.replace(/^#/, '');
            if (!targetId) return;

            // detect "home" path, supports /, /fr, /fr-CA
            const isHomePath = (p) => p === '/' || /^\/[a-z]{2}(-[A-Z]{2})?\/?$/.test(p);
            const onHome = isHomePath(window.location.pathname);

            if (onHome) {
                // smooth scroll on current page — only if the target exists here
                const targetEl = document.getElementById(targetId);
                if (!targetEl) return; // let the browser handle it / no-op
                e.preventDefault();
                const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: targetPosition - 100, // Adds 100px offset
                    behavior: 'smooth'
                });
            } else {
                // redirect to same locale prefix + #target
                e.preventDefault();
                const segments = window.location.pathname.split('/').filter(Boolean);
                const maybeLocale = segments[0];
                const localePrefix = /^[a-z]{2}(-[A-Z]{2})?$/.test(maybeLocale) ? `/${maybeLocale}` : '';
                window.location.href = `${localePrefix || ''}/#${targetId}`;
            }
        } catch (_) {
            // ignore malformed
        }
    });
})();
